





















import {Component, Vue, Watch} from "vue-property-decorator";
import DashboardMenu from "@/components/Dashboard/DashboardMenu.vue";
import DashboardBasicInfo from "@/components/Dashboard/DashboardBasicInfo.vue";
import LoadingModal from "@/components/Shared/LoadingModal.vue";
import PendingOrdersWarning from "@/components/Dashboard/PendingOrdersWarning.vue";

@Component({
  components: {PendingOrdersWarning, LoadingModal, DashboardBasicInfo, DashboardMenu}
})
export default class DashboardLayout extends Vue {
  private isFirstPage = false;

  checkIsFirstPage() {
    this.isFirstPage = this.$route.matched.some(({name}) => name === 'dashboard-first-page');
  }

  get extraClasses() {
    if (this.isFirstPage) {
      return "first-page";
    }
    return "";
  }

  mounted() {
    this.checkIsFirstPage();
  }

  @Watch('$route')
  onRouteChanged() {
    this.checkIsFirstPage();
  }
}
